export default class PsConst {

    static THEME__IS_DARK_THEME: string = 'THEME__IS_DARK_THEME';

    static LANGUAGE__LANGUAGE_CODE_KEY: string =
        'LANGUAGE__LANGUAGE_CODE_KEY';
    static LANGUAGE__COUNTRY_CODE_KEY: string = 'LANGUAGE__COUNTRY_CODE_KEY';
    static LANGUAGE__LANGUAGE_NAME_KEY: string =
        'LANGUAGE__LANGUAGE_NAME_KEY';

    static APP_INFO__END_DATE_KEY: string = 'END_DATE';
    static APP_INFO__START_DATE_KEY: string = 'START_DATE';
    static APPINFO_PREF_VERSION_NO: string = 'APPINFO_PREF_VERSION_NO';
    static APPINFO_PREF_FORCE_UPDATE: string = 'APPINFO_PREF_FORCE_UPDATE';
    static APPINFO_FORCE_UPDATE_MSG: string = 'APPINFO_FORCE_UPDATE_MSG';
    static APPINFO_FORCE_UPDATE_TITLE: string = 'APPINFO_FORCE_UPDATE_TITLE';
    static CREDIT_CARD_NO: string = 'CREDIT_CARD_NO';
    static CREDIT_CARD_DATE: string = 'CREDIT_CARD_DATE';
    static CREDIT_CARD_CVV: string = 'CREDIT_CARD_CVV';
    static CREDIT_CARD_NAME: string = 'CREDIT_CARD_NAME';
    static USER_EMAIL: string = 'USER_EMAIL';

    static FILTERING__DESC: string = 'desc'; // Don't Change
    static FILTERING__ASC: string = 'asc'; // Don't Change
    static FILTERING__ORDERING: string = 'ordering'; // Don't Change
    static FILTERING__ADDED_DATE: string = 'added_date'; // Don't Change
    static FILTERING__TRENDING: string = 'touch_count'; // Don't Change
    static FILTERING__FOLLOWING: string = 'following'; // Don't Change
    static FILTERING__FOLLOWER: string = 'follower'; // Don't Change
    static PAID_ITEM_FIRST: string = 'paid_item_first'; // Don't Change
    static ONLY_PAID_ITEM: string = 'only_paid_item'; // Don't Change
    static PAID_AD_PROGRESS: string = 'Progress'; // Don't Change
    static CHAT_TYPE_BUYER: string = 'buyer'; // Don't Change
    static CHAT_TYPE_SELLER: string = 'seller'; // Don't Change
    static CHAT_TO_BUYER: string = 'to_buyer'; // Don't Change
    static CHAT_TO_SELLER: string = 'to_seller'; // Don't Change
    static ITEM_TYPE: string = 'item'; // Don't Change
    static ENGINE_STATUS_ZERO: string = '0'; // Don't Change
    static ENGINE_STATUS_ONE: string = '1'; // Don't Change
    static LIMITED: string = 'limited'; // Don't Change
    static UNLIMITED: string = 'unlimited'; // Don't Change

    static ONE: string = '1';
    static FILTERING_FEATURE: string = 'featured_date';
    static FILTERING_TRENDING: string = 'touch_count';

    static PLATFORM: string = 'frontend';

    static RATING_ONE: string = '1';
    static RATING_TWO: string = '2';
    static RATING_THREE: string = '3';
    static RATING_FOUR: string = '4';
    static RATING_FIVE: string = '5';

    static IS_DISCOUNT: string = '1';
    static IS_FEATURED: string = '1';
    static ZERO: string = '0';
    static THREE: string = '3';

    static GOOGLE_AD: string = 'google_ad';
    static NORMAL_AD: string = 'normal_ad';
    static PAID_AD: string = 'paid_ad';

    static FILTERING_PRICE: string = 'unit_price';
    static FILTERING_NAME: string = 'title';

    static USER_DELECTED: string = 'deleted';
    static USER_BANNED: string = 'banned';
    static USER_UN_PUBLISHED: string = 'unpublished';

    static ADD_NEW_ITEM: string = 'ADD_NEW_ITEM';
    static EDIT_ITEM: string = 'EDIT_ITEM';

    static VALUE_HOLDER__USER_ID: string = 'USERID';
    static VALUE_HOLDER__USER_NAME: string = 'USER_NAME';
    static VALUE_HOLDER__NOTI_TOKEN: string = 'NOTI_TOKEN';
    static VALUE_HOLDER__NOTI_MESSAGE: string = 'NOTI_MESSAGE';
    static VALUE_HOLDER__NOTI_SETTING: string = 'NOTI_SETTING';
    static VALUE_HOLDER__CAMERA_SETTING: string = 'CAMERA_SETTING';
    static VALUE_HOLDER__USER_ID_TO_VERIFY: string = 'USERIDTOVERIFY';
    static VALUE_HOLDER__USER_NAME_TO_VERIFY: string = 'USER_NAME_TO_VERIFY';
    static VALUE_HOLDER__USER_EMAIL_TO_VERIFY: string =
        'USER_EMAIL_TO_VERIFY';
    static VALUE_HOLDER__USER_PASSWORD_TO_VERIFY: string =
        'USER_PASSWORD_TO_VERIFY';
    static VALUE_HOLDER__START_DATE: string = 'START_DATE';
    static VALUE_HOLDER__END_DATE: string = 'END_DATE';
    static VALUE_HOLDER__PAYPAL_ENABLED: string = 'PAYPAL_ENABLED';
    static VALUE_HOLDER__STRIPE_ENABLED: string = 'STRIPE_ENABLED';
    static VALUE_HOLDER__COD_ENABLED: string = 'COD_ENABLED';
    static VALUE_HOLDER__BANK_TRANSFER_ENABLE: string =
        'BANK_TRANSFER_ENABLE';
    static VALUE_HOLDER__PUBLISH_KEY: string = 'PUBLISH_KEY';
    static VALUE_HOLDER__NOUNCE_KEY: string = 'NOUNCE_KEY';
    static VALUE_HOLDER__IS_HAS_CREDIT_CARE: string = 'IS_HAS_CREDIT_CARE';
    static VALUE_HOLDER__DEPOSIT_PERCENTAGE: string = 'DEPOSIT_PERCENTAGE';
    static VALUE_HOLDER__RESULT_START_TIME: string = 'RESULT_START_TIME';
    static VALUE_HOLDER__COOLDOWN_PERIOD: string = 'COOLDOWN_PERIOD';
    static VALUE_HOLDER__MEMBERSHIP_DURATION: string = 'MEMBERSHIP_DURATION';
    static VALUE_HOLDER__MEMBERSHIP_AMOUNT: string = 'MEMBERSHIP_AMOUNT';
    static VALUE_HOLDER__STANDART_SHIPPING_ENABLE: string =
        'STANDART_SHIPPING_ENABLE';
    static VALUE_HOLDER__ZONE_SHIPPING_ENABLE: string =
        'ZONE_SHIPPING_ENABLE';
    static VALUE_HOLDER__NO_SHIPPING_ENABLE: string = 'NO_SHIPPING_ENABLE';
    static VALUE_HOLDER__LOCATION_ID: string = 'LOCATION_ID';
    static VALUE_HOLDER__LOCATION_NAME: string = 'LOCATION_NAME';
    static VALUE_HOLDER__LOCATION_LAT: string = 'LOCATION_LAT';
    static VALUE_HOLDER__LOCATION_LNG: string = 'LOCATION_LNG';

    static CALL_BACK_EDIT_TO_PROFILE: string = 'CALL_BACK_EDIT_TO_PROFILE';

    static MANUFACTURER_ID: string = 'manufacturer_id';
    static MODEL_ID: string = 'model_id';
    static MANUFACTURER_NAME: string = 'manufacturer_name';

    static CONST_CATEGORY: string = 'category';
    static CONST_SUB_CATEGORY: string = 'subcategory';
    static CONST_PRODUCT: string = 'product';

    static VIEW_MAP: string = 'VIEW_MAP';
    static PIN_MAP: string = 'PIN_MAP';
    static INVALID_LAT_LNG: string = '0.000000';

    static VALUE_HOLDER__OVERALL_TAX_LABEL: string = 'OVERALL_TAX_LABEL';
    static VALUE_HOLDER__OVERALL_TAX_VALUE: string = 'OVERALL_TAX_VALUE';
    static VALUE_HOLDER__SHIPPING_TAX_LABEL: string = 'SHIPPING_TAX_LABEL';
    static VALUE_HOLDER__SHIPPING_TAX_VALUE: string = 'SHIPPING_TAX_VALUE';
    static VALUE_HOLDER__SHIPPING_ID: string = 'SHIPPING_ID';
    static VALUE_HOLDER__SHOP_ID: string = 'shop_id';
    static VALUE_HOLDER__MESSENGER: string = 'messenger';
    static VALUE_HOLDER__WHATSAPP: string = 'whapsapp_no';
    static VALUE_HOLDER__PHONE: string = 'about_phone1';
    static FILTERING_TYPE_NAME_PRODUCT: string = 'product';
    static FILTERING_TYPE_NAME_CATEGORY: string = 'category';
    static REQUEST_CODE__MENU_USER_PROFILE_FRAGMENT: Number = 1001;
    static REQUEST_CODE__MENU_FORGOT_PASSWORD_FRAGMENT: Number = 1002;
    static REQUEST_CODE__MENU_REGISTER_FRAGMENT: Number = 1003;
    static REQUEST_CODE__MENU_VERIFY_EMAIL_FRAGMENT: Number = 1004;
    static REQUEST_CODE__MENU_HOME_FRAGMENT: Number = 1005;
    static REQUEST_CODE__MENU_LATEST_PRODUCT_FRAGMENT: Number = 1006;
    static REQUEST_CODE__MENU_DISCOUNT_PRODUCT_FRAGMENT: Number = 1007;
    static REQUEST_CODE__MENU_FEATURED_PRODUCT_FRAGMENT: Number = 1008;
    static REQUEST_CODE__MENU_TRENDING_PRODUCT_FRAGMENT: Number = 1009;
    static REQUEST_CODE__MENU_COLLECTION_FRAGMENT: Number = 1010;
    static REQUEST_CODE__MENU_SELECT_WHICH_USER_FRAGMENT: Number = 1011;
    static REQUEST_CODE__MENU_LANGUAGE_FRAGMENT: Number = 1012;
    static REQUEST_CODE__MENU_SETTING_FRAGMENT: Number = 1013;
    static REQUEST_CODE__MENU_LOGIN_FRAGMENT: Number = 1014;
    static REQUEST_CODE__MENU_BLOG_FRAGMENT: Number = 1015;
    static REQUEST_CODE__MENU_FAVOURITE_FRAGMENT: Number = 1016;
    static REQUEST_CODE__MENU_TRANSACTION_FRAGMENT: Number = 1017;
    static REQUEST_CODE__MENU_USER_HISTORY_FRAGMENT: Number = 1018;
    static REQUEST_CODE__MENU_TERMS_AND_CONDITION_FRAGMENT: Number = 1019;
    static REQUEST_CODE__MENU_CATEGORY_FRAGMENT: Number = 1020;
    static REQUEST_CODE__MENU_CONTACT_US_FRAGMENT: Number = 1021;
    static REQUEST_CODE__MENU_PHONE_SIGNIN_FRAGMENT: Number = 1022;
    static REQUEST_CODE__MENU_PHONE_VERIFY_FRAGMENT: Number = 1023;
    static REQUEST_CODE__MENU_FB_SIGNIN_FRAGMENT: Number = 1024;
    static REQUEST_CODE__MENU_GOOGLE_VERIFY_FRAGMENT: Number = 1025;
    static REQUEST_CODE__MENU_OFFER_FRAGMENT: Number = 2026;
    static REQUEST_CODE__MENU_SELLING_ITEM_FRAGMENT: Number = 1027;
    static REQUEST_CODE__MENU_BUYING_ITEM_FRAGMENT: Number = 1028;
    static REQUEST_CODE__MENU_BLOCKED_USER_FRAGMENT: Number = 2027;
    static REQUEST_CODE__MENU_REPORTED_ITEM_FRAGMENT: Number = 2028;

    static REQUEST_CODE__DASHBOARD_USER_PROFILE_FRAGMENT: Number = 2001;
    static REQUEST_CODE__DASHBOARD_FORGOT_PASSWORD_FRAGMENT: Number = 2002;
    static REQUEST_CODE__DASHBOARD_REGISTER_FRAGMENT: Number = 2003;
    static REQUEST_CODE__DASHBOARD_VERIFY_EMAIL_FRAGMENT: Number = 2004;
    static REQUEST_CODE__DASHBOARD_CATEGORY_FRAGMENT: Number = 2005;
    static REQUEST_CODE__DASHBOARD_SELECT_WHICH_USER_FRAGMENT: Number = 2006;
    static REQUEST_CODE__DASHBOARD_SEARCH_FRAGMENT: Number = 2007;
    static REQUEST_CODE__DASHBOARD_MESSAGE_FRAGMENT: Number = 2008;
    static REQUEST_CODE__DASHBOARD_LOGIN_FRAGMENT: Number = 2009;
    static REQUEST_CODE__DASHBOARD_PHONE_SIGNIN_FRAGMENT: Number = 2010;
    static REQUEST_CODE__DASHBOARD_PHONE_VERIFY_FRAGMENT: Number = 2011;
    static REQUEST_CODE__DASHBOARD_FB_SIGNIN_FRAGMENT: Number = 2012;
    static REQUEST_CODE__DASHBOARD_GOOGLE_VERIFY_FRAGMENT: Number = 2013;

    static ADSPROGRESS: string = 'Progress';
    static ADSFINISHED: string = 'Finished';
    static ADSNOTYETSTART: string = 'Not yet start';
    static ADSNOTAVAILABLE: string = 'not_available';

    static CHAT_TYPE_TEXT: Number = 0;
    static CHAT_TYPE_IMAGE: Number = 1;
    static CHAT_TYPE_OFFER: Number = 2;
    static CHAT_TYPE_DATE: Number = 3;
    static CHAT_TYPE_SOLD: Number = 4;
    static CHAT_TYPE_BOUGHT: Number = 5;
    static CHAT_TYPE_ACCEPT: Number = 0;
    static CHAT_TYPE_REJECT: Number = 0;

    static CHAT_STATUS_NULL: Number = 0;
    static CHAT_STATUS_OFFER: Number = 1;
    static CHAT_STATUS_REJECT: Number = 2;
    static CHAT_STATUS_ACCEPT: Number = 3;
    static CHAT_STATUS_SOLD: Number = 4;
    static CHAT_STATUS_IS_USER_BOUGHT: Number = 5;
    
    static CHAT_FROM_BUYER: string = 'CHAT_FROM_BUYER';
    static CHAT_FROM_SELLER: string = 'CHAT_FROM_SELLER';
    static HIDE_ITEM: string = 'hide_item';

    static PAYMENT_PAYPAL_METHOD: string = 'paypal';
    static PAYMENT_STRIPE_METHOD: string = 'stripe';
    static PAYMENT_RAZOR_METHOD: string = 'razor';
    static PAYMENT_OFFLINE_METHOD: string = 'offline';
    static PAYMENT_PAY_STACK_METHOD: string = 'paystack';
    static PAYMENT_IN_APP_PURCHASE_METHOD: string = 'In_App_Purchase';

    ///
    /// Hero Tags
    ///
    static HERO_TAG__IMAGE: string = '_image';
    static HERO_TAG__TITLE: string = '_title';
    static HERO_TAG__ORIGINAL_PRICE: string = '_original_price';
    static HERO_TAG__UNIT_PRICE: string = '_unit_price';

    ///
    /// Payment On/Off
    ///
    static PAYPAL_ENABLE: string = '1';
    static STRIPE_ENABLE: string = '1';
    static RAZOR_ENABLE: string = '1';
    static OFFLINE_PAYMENT_ENABLE: string = '1';

    ///
    /// Firebase Auth Providers
    ///
    static emailAuthProvider: string = 'password';
    static appleAuthProvider: string = 'apple';
    static facebookAuthProvider: string = 'facebook';
    static googleAuthProvider: string = 'google';
    static defaultEmail: string = 'admin@ps.com';
    static defaultPassword: string = 'admin@ps.com';

    
    ///
    /// Error Codes
    ///
    static ERROR_CODE_10001: string = '10001'; // Totally No Record
    static ERROR_CODE_10002: string =
        '10002'; // No More Record at pagination

    /// No Login User
    static NO_LOGIN_USER : string = 'nologinuser';
}